export const UNIT_TYPE = Object.freeze({
  lesson: 'lesson',
  assessment: 'assessment'
});
